"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
(() => {
    const carOfferHeader = document.querySelector('.car-offer-header');
    const openGalleryItem = document.querySelector('.open-gallery-item');
    const buttonSlideDown = document.querySelector('.button-slide-down');
    const firstGalleryImage = document.querySelector('.car-offer-header-gallery .gallery-main-image .gallery-image');
    const stickyPanel = document.querySelector('#sticky-panel-container');
    const adminLeasingInfo = document.querySelector('.admin-leasing-info');
    function handleOpenGalleryItemClick() {
        if (openGalleryItem === null || firstGalleryImage === null) {
            return;
        }
        openGalleryItem.addEventListener('click', (evt) => {
            evt.preventDefault();
            firstGalleryImage.click();
        });
    }
    function handleButtonSlideDownClick() {
        if (buttonSlideDown === null) {
            return;
        }
        buttonSlideDown.addEventListener('click', (evt) => {
            evt.preventDefault();
            const element = document.getElementById('car-introduction-detail-container');
            if (element === null) {
                return;
            }
            window.scrollTo({
                top: element.getBoundingClientRect().top + window.scrollY,
                behavior: 'smooth',
            });
        });
    }
    function handleScroll() {
        if (stickyPanel === null || carOfferHeader === null) {
            return;
        }
        const offerVariantsTabs = document.querySelector('.offer-variants-tabs');
        if (offerVariantsTabs === null) {
            setTimeout(handleScroll, 20);
        }
        else {
            const carOfferHeaderBottomOffset = Number(carOfferHeader.offsetTop + carOfferHeader.offsetHeight);
            window.addEventListener('scroll', () => {
                const scrollTop = window.scrollY;
                if (scrollTop > carOfferHeaderBottomOffset) {
                    stickyPanel.classList.add('fixed');
                }
                else {
                    stickyPanel.classList.remove('fixed');
                }
            });
        }
    }
    function filterAdminCarList(selectedMileage, selectedContractLength) {
        const items = Array.from(document.querySelectorAll('.car-list-by-status .list .filter-item'));
        items.forEach((item) => {
            const mileages = Array.from(item.querySelectorAll('.detail-label-mileage-yearly'));
            const contractLengths = Array.from(item.querySelectorAll('.detail-label-contract-length'));
            let displayByMileage = false;
            let displayByContractLength = false;
            mileages.forEach((element) => {
                const { mileage } = element.dataset;
                if (selectedMileage.length === 0 || mileage === selectedMileage) {
                    displayByMileage = true;
                }
            });
            contractLengths.forEach((element) => {
                const { contractLength } = element.dataset;
                if (selectedContractLength.length === 0 || contractLength === selectedContractLength) {
                    displayByContractLength = true;
                }
            });
            if (displayByMileage && displayByContractLength) {
                DisplayAnimation_1.default.show(item);
            }
            else {
                DisplayAnimation_1.default.hide(item);
            }
        });
    }
    function adminLeasingInfoFilter() {
        if (adminLeasingInfo === null) {
            return;
        }
        const contractLengthSelect = adminLeasingInfo
            .querySelector('#admin-contract-length-select');
        const mileageSelect = adminLeasingInfo.querySelector('#admin-mileage-select');
        if (contractLengthSelect === null || mileageSelect === null) {
            return;
        }
        mileageSelect.addEventListener('change', () => {
            filterAdminCarList(mileageSelect.value, contractLengthSelect.value);
        });
        contractLengthSelect.addEventListener('change', () => {
            filterAdminCarList(mileageSelect.value, contractLengthSelect.value);
        });
    }
    handleButtonSlideDownClick();
    handleOpenGalleryItemClick();
    adminLeasingInfoFilter();
    handleScroll();
})();
